import Vue from 'vue';
import Vuex from 'vuex';
import organization from './organization';
import user from './user';
import hierarchy from './hierarchy';
import superAdmin from './super-admin';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    organization,
    user,
    hierarchy,
    superAdmin,
  },
});

export default store;
